import { render, staticRenderFns } from "./HasAppliedForMoreInformation.vue?vue&type=template&id=aa4a7b72&"
import script from "./HasAppliedForMoreInformation.vue?vue&type=script&lang=ts&"
export * from "./HasAppliedForMoreInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HasAppliedForMoreInformation.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5Ccommon%5CHasAppliedForMoreInformation.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports